module.exports = __webpack_public_path__ + "img/f_25_01.ad67cfd7.jpg";